import { useQuery } from "react-query";
import { getDoorBuzzersByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetDoorBuzzersByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetDoorBuzzersByRecordNumber", recNumber],
    () => getDoorBuzzersByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
